import * as React from 'react';
import cx from 'classnames';
import { Menu } from '@dropbox/dig-components/menu';
import { RowIcon } from './row_icon';
import { Badge } from '@dropbox/dig-components/badge';
import { generateGHLogName } from '../utils';
export const Row = ({ item, useHrefDirectly }) => {
    const title = (React.createElement("div", { className: "dpc-Waffle-row-title" },
        item.title,
        item.badge && (React.createElement(Badge, { className: "dpc-Waffle-row-branding" }, item.badge))));
    const subtitle = (React.createElement("div", { className: "dpc-Waffle-row-subtitle" }, item.subtitle));
    /* data-uxa-log is used for user analytics logging, it is automated on metaserver */
    return (React.createElement(Menu.ActionItem, { className: cx('dpc-Waffle-row-wrapper', item.className), value: item, withLeftAccessory: React.createElement(RowIcon, { item: item }), withSubtitle: subtitle, "data-uxa-log": generateGHLogName('waffle', item.id), tagName: "a", target: "_blank", href: useHrefDirectly ? item.href : undefined }, title));
};
Row.displayName = 'Row';
